import { render, staticRenderFns } from "./gameTransactionBackview.vue?vue&type=template&id=3361d78d&"
import script from "./gameTransactionBackview.vue?vue&type=script&lang=js&"
export * from "./gameTransactionBackview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports